import en from './en.json'
import ro from './ro.json'

export const defaultLocale = 'en'

export const languages = {
  en: en,
  ro: ro
}
